import Vue from "vue";
import Router from "vue-router";
import Interact from "@/components/classification/Interact";
import VideoRecorder from "@/components/classification/VideoRecorder";
import AudioRecorder from "@/components/classification/AudioRecorder";
import VoiceMatching from "@/components/classification/VoiceMatching";
import FaceMatching from "@/components/classification/FaceMatching";
import CSAMDemo from "@/components/classification/CSAMDemo";
import CaptchaTest from "@/components/classification/CaptchaTest";
import ContinuousAge from "@/components/classification/ContinuousAge";
import ContinuousAgeIframe from "@/components/classification/ContinuousAgeIframe";
import AgeAvatar from "@/components/classification/AgeAvatar";
import DigitalGuardianFAQ from "@/components/classification/DigitalGuardianFAQ";
import ContentModeration from "@/components/classification/ContentModeration";
import AgeAI from "@/components/classification/AgeAI";
import ArcoscanIframe from "@/components/classification/ArcoscanIframe";

import NudityDemo from "@/components/classification/NudityDemo";
import InteractProJuventute from "@/components/classification/InteractProJuventute";
import Keyboard from "@/components/keyboard/Keyboard";
import Firebase from "firebase/app";
import "firebase/auth";

import SignIn from "@/components/authentication/SignIn";
import SignUp from "@/components/authentication/SignUp";
import TwitchDemo from "@/components/videochat/TwitchDemo";
import Home from "@/components/home/Home";
import Embed from "@/components/common/Embed.vue";
import TermsAndConditions from "@/components/TermsAndConditions";

Vue.use(Router);

let routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/video",
    name: "video",
    component: TwitchDemo,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/hate_toxicity",
    name: "hate_toxicity",
    component: Interact,
    meta: {
      requiresAuth: false
    },
    props: {
      classifierNames: ["profanity_en", "hate", "toxicity"]
    }
  },
  {
    path: "/text_age_verification",
    name: "text_age_verification",
    component: Interact,
    meta: {
      requiresAuth: false
    },
    props: {
      classifierNames: ["text_age_verification"]
    }
  },
  {
    path: "/video_age_verification",
    name: "video_age_verification",
    component: VideoRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/audio_recording",
    name: "audio_recording",
    component: AudioRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/voice_captcha_demo",
    name: "voice_captcha_demo",
    component: CaptchaTest,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/voice_print",
    name: "voice_print",
    component: VoiceMatching,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/faceverify",
    name: "faceverify",
    component: FaceMatching,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/continuous_age_estimation",
    name: "continuous_age_estimation",
    component: ContinuousAge,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/continuous_age_estimation_iframe",
    name: "continuous_age_estimation_iframe",
    component: ContinuousAgeIframe,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/ageavatar",
    name: "ageavatar",
    component: AgeAvatar,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/digital_guardian_faq",
    name: "digital_guardian_faq",
    component: DigitalGuardianFAQ,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/content_moderation",
    name: "content_moderation",
    component: ContentModeration,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/age_ai",
    name: "age_ai",
    component: AgeAI,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/aiframe",
    name: "aiframe",
    component: ArcoscanIframe,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/csam_demo",
    name: "csam_demo",
    component: CSAMDemo,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/nudity_demo",
    name: "nudity_demo",
    component: NudityDemo,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/ageassure",
    name: "ageassure",
    beforeEnter() {
      location.href = "#";
    }
  },
  {
    path: "/faceassure",
    name: "faceassure",
    beforeEnter() {
      location.href = "#";
    }
  },
  {
    path: "/restrictedretail",
    name: "restrictedretail",
    beforeEnter() {
      location.href = "https://retail-store-demo.privately.swiss/";
    }
  },
  {
    path: "/video_age_verification_pytorch",
    name: "video_age_verification_pytorch",
    component: VideoRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/video_age_verification_overlay",
    name: "video_age_verification_overlay",
    component: VideoRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/face_detection",
    name: "face_detection",
    component: VideoRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/mask_detection",
    name: "mask_detection",
    component: VideoRecorder,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/interact-pj",
    name: "interact-pj",
    component: InteractProJuventute,
    meta: {
      requiresAuth: false
    },
    props: {}
  },
  {
    path: "/interact",
    name: "interact",
    component: Interact,
    meta: {
      requiresAuth: false
    },
    props: {}
  },
  {
    path: "/exp_hate_toxicity",
    name: "exp_hate_toxicity",
    component: Interact,
    meta: {
      requiresAuth: false
    },
    props: {
      classifierNames: [
        "toxicity",
        "unbiased_toxicity",
        "severe_toxicity",
        "obscene",
        "identity_attack",
        "insult",
        "threat",
        "sexual_explicit"
      ]
    }
  },
  {
    path: "/emotion",
    name: "emotion",
    component: Interact,
    meta: {
      requiresAuth: false
    },
    props: {
      classifierNames: ["emotion_ensemble", "sentiment"]
    }
  },

  {
    path: "/keyboard",
    name: "keyboard",
    component: Keyboard,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/violence",
    name: "violence",
    component: Embed,
    props: {
      src: "https://modemos.privately.swiss/violence"
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/multimodal_emotion",
    name: "multimodal_emotion",
    component: Embed,
    props: {
      src: "https://modemos.privately.swiss/emotion"
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/emotionFace",
    name: "emotionFace",
    component: Embed,
    props: {
      src: "https://modemos.privately.swiss/emotionFace"
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/sign-in",
    name: "signIn",
    component: SignIn
  },
  {
    path: "/sign-up",
    name: "signUp",
    component: SignUp
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditions",
    component: TermsAndConditions
  }
];

let router = new Router({
  //   base: common.state.basePath,
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

// Check before each page load whether the page requires authentication/
// if it does check whether the user is signed into the web app or
// redirect to the sign-in page to enable them to sign-in
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    const currentUser = Firebase.auth().currentUser;
    if (!currentUser) {
      next({ path: "/sign-in", query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
